import React from 'react';
import { useUser } from '@clerk/clerk-react';

function MarketingHeader() {
  const { user } = useUser();

  return (
    <header className="mkt-header">
      <div className="mkt-header-left">
        <h1 className="mkt-header-title">Marketing Ops</h1>
      </div>
      <div className="mkt-header-right">
        <span className="mkt-header-user">
          {user?.firstName || 'Admin'}
        </span>
      </div>
    </header>
  );
}

export default MarketingHeader;
